import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable id-length */

/**
 * @param {string} text string
 * Hyphenates all spaces and +
 */
var hyphenateSpaces = function hyphenateSpaces(text) {
  return text.toLowerCase().replace(/((%20)|\s|\+)+/g, '-');
};
/**
 * @param {string} text string
 * Strips everything but A-Z, a-z, 0-9, hyphens but removes hyphens at start and end
 */


var stripPunctuation = function stripPunctuation(text) {
  return text.replace(/[^a-zA-Z0-9-]/g, '').replace(/^-*|-*$/g, '');
};
/**
 * @param {string} text Encoded string
 */


var encode = function encode(text) {
  return text.replace(/-/g, '%252D').replace(/%20/g, '-').replace(/%2B/g, '+');
};
/**
 * @param {string} text Encoded string
 */


var decode = function decode(text) {
  return text.replace(/-/g, '%20').replace(/%252D/g, '-');
};
/**
 * @param {string} text Encoded string
 */


var getSanitised = function getSanitised(text) {
  return decodeURIComponent(decode(text));
};

var getCategoriesJoined = function getCategoriesJoined(categories) {
  return categories ? categories.join('/') : '';
};

var getEncodedBrowseCategories = function getEncodedBrowseCategories(categories) {
  return categories ? categories.map(function (category) {
    return stripPunctuation(hyphenateSpaces(category));
  }).filter(function (category) {
    return category;
  }) : '';
};

var getCategoryFilterPath = function getCategoryFilterPath(categoryId) {
  var isBrowse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isBrowse) {
    return categoryId ? "c:".concat(categoryId, "/") : '';
  }

  return categoryId ? "category:".concat(categoryId, "/") : '';
};

var sortByValues = [{
  key: 'relevance_desc',
  value: {
    type: 'relevance',
    order: 'desc'
  },
  label: 'Most Popular',
  path: 'sort:relevance:desc'
}, {
  key: 'price_asc',
  value: {
    type: 'price',
    order: 'asc'
  },
  label: 'Price: Low - High',
  path: 'sort:price'
}, {
  key: 'price_desc',
  value: {
    type: 'price',
    order: 'desc'
  },
  label: 'Price: High - Low',
  path: 'sort:price:desc'
}, {
  key: 'customer rating_desc',
  value: {
    type: 'customer rating',
    order: 'desc'
  },
  label: 'Customer Rating',
  path: 'sort:customer-rating'
}, {
  key: 'newness_desc',
  value: {
    type: 'newness',
    order: 'desc'
  },
  label: 'New Arrivals',
  path: 'sort:new-arrivals'
}];

var refinementKeySort = function refinementKeySort(akey, bkey) {
  var nameA = akey.toUpperCase();
  var nameB = bkey.toUpperCase();
  var brandsLabel = 'brands';

  if (nameA === brandsLabel.toUpperCase()) {
    return -1;
  }

  if (nameB === brandsLabel.toUpperCase()) {
    return 1;
  }

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
};

var refinementSort = function refinementSort(akey, bkey) {
  var nameA = akey.toUpperCase();
  var nameB = bkey.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
};

var getOptionsPath = function getOptionsPath(pageNumber, sortBy, searchType, categoryMatch) {
  var defaultSortKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'relevance_desc';
  var optionalPath = 'opt/';

  var getPageNumber = function getPageNumber() {
    return pageNumber === 1 || !pageNumber ? '' : "page:".concat(pageNumber, "/");
  };

  var getSortBy = function getSortBy() {
    if (!sortBy) {
      return '';
    } // The path for the default sort must be empty ''


    var sortWithDefault = sortByValues.map(function (sort) {
      if (sort.key === defaultSortKey) {
        return _objectSpread(_objectSpread({}, sort), {}, {
          path: ''
        });
      }

      return sort;
    });
    var key = Object.keys(sortBy)[0];
    var sortByObject = sortWithDefault.find(function (value) {
      return value.key === "".concat(key, "_").concat(sortBy[key]);
    });
    return "".concat(sortByObject && sortByObject.path ? "".concat(sortByObject.path, "/") : '');
  };

  var getSearchType = function getSearchType() {
    if (typeof searchType === 'string' || searchType instanceof String) {
      var searchTypePath = encode(encodeURIComponent(searchType.toLowerCase()));
      return "type:".concat(searchTypePath, "/");
    }

    return '';
  };

  var getCategoryMatch = function getCategoryMatch() {
    return typeof categoryMatch === 'string' || categoryMatch instanceof String ? "catmatch:".concat(categoryMatch, "/") : '';
  };

  if (!getPageNumber() && !getSortBy() && !getSearchType() && !getCategoryMatch()) {
    return '';
  }

  optionalPath += getSearchType();
  optionalPath += getCategoryMatch();
  optionalPath += getPageNumber();
  optionalPath += getSortBy();
  return optionalPath;
};

var getRefinementPath = function getRefinementPath(filterUriFragments) {
  if (!filterUriFragments || Object.keys(filterUriFragments).length < 1) {
    return '';
  }
  /**
   * Search engine encodes the filter value but not the type
   * i.e filter[not encoded type] = encodedValue
   */


  var encodeRefinementValue = function encodeRefinementValue(refinement) {
    return encode(refinement.replace(/\+/g, '%20').replace(/,/g, '%2C').replace(/%2C/g, '%252C'));
  };

  var encodeRefinementName = function encodeRefinementName(refinement) {
    return encode(encodeURIComponent(refinement).replace('%2F', '%252F'));
  };

  var urlString = '';
  var filterKeys = [];
  filterKeys.push.apply(filterKeys, _toConsumableArray(Object.keys(filterUriFragments)));
  filterKeys.sort(refinementKeySort);
  filterKeys.forEach(function (facet) {
    filterUriFragments[facet].sort(refinementSort);
    filterUriFragments[facet].forEach(function (filters, i) {
      if (i === 0) {
        urlString += "".concat(encodeRefinementName(facet), ":").concat(encodeRefinementValue(filters));
      } else {
        urlString += ",".concat(encodeRefinementValue(filters));
      }

      if (i + 1 === filterUriFragments[facet].length) {
        urlString += '/';
      }
    });
  });
  return urlString;
};

var getCommonParametersPath = function getCommonParametersPath(params) {
  var isBrowse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sortBy = params.sortBy,
      pageNumber = params.pageNumber,
      searchType = params.searchType,
      categoryMatch = params.categoryMatch,
      defaultSortKey = params.defaultSortKey;
  var path = '';
  var categoryPath = getCategoryFilterPath(params.categoryId, isBrowse);

  if (typeof params.filterUriFragments !== 'undefined' && params.filterUriFragments) {
    delete params.filterUriFragments.category;
    /* eslint-disable-line */
  }

  var refinementPath = getRefinementPath(params.filterUriFragments);
  var optionalPath = getOptionsPath(pageNumber, sortBy, searchType, categoryMatch, defaultSortKey);
  path += "".concat(categoryPath).concat(refinementPath).concat(optionalPath);
  return path;
};

var getSearchPath = function getSearchPath(searchTerm) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path;

  if (searchTerm) {
    var term = searchTerm.trim().toLowerCase();
    var pageType = params.isCannedSearch ? 'list' : 'search';
    path = "/".concat(pageType, "/").concat(encodeURIComponent(term), "/");
    path = encode(path);
  } else {
    throw new Error('No search term supplied');
  }

  path += getCommonParametersPath(params);
  return path;
};

var getBrowsePath = function getBrowsePath() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path;

  if (params.categoryId) {
    var pageType = params.isClearance ? 'clearance' : 'browse';
    path = "/".concat(pageType, "/").concat(getCategoriesJoined(getEncodedBrowseCategories(params.categories)), "/");
  } else {
    throw new Error('No category id supplied');
  }

  path += getCommonParametersPath(params, true);
  return path;
};

export { getSearchPath, getBrowsePath, getCategoryFilterPath, getOptionsPath, getRefinementPath, getEncodedBrowseCategories, getCategoriesJoined, refinementSort, refinementKeySort, hyphenateSpaces, stripPunctuation, encode, decode, getSanitised };